"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _PanelSelectCamps = require("./PanelSelectCamps.css");

var _PanelSelectCamps2 = _interopRequireDefault(_PanelSelectCamps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//     

var updatedList = [];

var PanelSelectCamps = function (_Component) {
	_inherits(PanelSelectCamps, _Component);

	function PanelSelectCamps(props) {
		_classCallCheck(this, PanelSelectCamps);

		var _this = _possibleConstructorReturn(this, (PanelSelectCamps.__proto__ || Object.getPrototypeOf(PanelSelectCamps)).call(this, props));

		_this.handleChange = function (event, data) {
			var selectedAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;


			var newList = new Set([].concat(_toConsumableArray(_this.props.selectedfields)));

			if (selectedAll) {

				newList = data.checked ? new Set([].concat(_toConsumableArray(CONSTANTS.DEFAULT_NUMERIC_FIELDS), _toConsumableArray(CONSTANTS.defaultJsonConfig.selectedfields))) : new Set(CONSTANTS.defaultJsonConfig.selectedfields);
			} else if (data.checked) {

				newList.add(data.label);
			} else {
				newList.delete(data.label);
			}

			var array = Array.from(newList);
			updatedList = array;
			// console.log('cc', updatedList.length)
			_this.props.updateJsonConfig(["calcdatafieldsOptions", "calcdatafieldsCalculs", "calcdatafields", "vieweroptions", "selectedfields"], [_extends({}, CONSTANTS.defaultJsonConfig.calcdatafieldsOptions, { granularitat: _this.props.timerange.dynamic && _this.props.timerange.singledays ? CONSTANTS.GRANULARITAT_HORES : CONSTANTS.GRANULARITAT_DIES }), CONSTANTS.defaultJsonConfig.calcdatafieldsCalculs, CONSTANTS.defaultJsonConfig.calcdatafields, CONSTANTS.defaultJsonConfig.vieweroptions, [].concat(_toConsumableArray(newList))]);
		};

		_this.handleDismissError = function () {
			return _this.setState({ missingSelectedFields: false });
		};

		_this.state = {
			fieldsList: [],
			loading: true,
			showError: false,
			errorMsg: "",
			missingSelectedFields: false
		};

		return _this;
	}

	_createClass(PanelSelectCamps, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			this.loadFields();
		}
	}, {
		key: "loadFields",
		value: function loadFields() {
			var _this2 = this;

			var _props = this.props,
			    data = _props.data,
			    timerange = _props.timerange;

			var databaseNameSuffix = timerange.tipus === CONSTANTS.LATEST ? CONSTANTS.SUFIX_ACTUAL : CONSTANTS.SUFIX_HISTORIC;
			var nameDB = data.isCSVFile ? data.databasename : "" + data.databasename + databaseNameSuffix;

			_request2.default.get(CONSTANTS.URL_GET_COLUMNS + "/" + nameDB + "/columns").then(function (data) {

				_this2.setState({ loading: false, fieldsList: data });
			}).catch(function (err) {

				_this2.setState({ loading: false, showError: true, errorMsg: err });
			});
		}
	}, {
		key: "renderFieldsItems",
		value: function renderFieldsItems() {
			var _this3 = this;

			var fieldsList = this.state.fieldsList;

			var listNum = [];
			// console.log('fields', listNum)
			var calcfields = new Set(CONSTANTS.DEFAULT_NUMERIC_FIELDS);

			fieldsList.map(function (item, i) {

				if (calcfields.has(item)) {
					// console.log('i', item)
					var isChecked = _this3.props.selectedfields.has(item);
					//const styleSelected =  isChecked ? styles.selectedLabel : {};

					if (item !== 'alt') {
						listNum.push(_react2.default.createElement(
							"div",
							{ className: _PanelSelectCamps2.default.checkboxItem, key: i },
							_react2.default.createElement(_semanticUiReact.Checkbox, { className: isChecked ? _PanelSelectCamps2.default.selectedLabel : "", checked: isChecked, onChange: _this3.handleChange, label: item })
						));
					}
					if (item === 'alt' && updatedList.length > 5) {
						listNum.push(_react2.default.createElement(
							"div",
							{ className: _PanelSelectCamps2.default.checkboxItem, key: i },
							_react2.default.createElement(_semanticUiReact.Checkbox, { className: isChecked ? _PanelSelectCamps2.default.selectedLabel : "", checked: isChecked, onChange: _this3.handleChange, label: item })
						));
					}
					if (item === 'alt' && updatedList.length <= 5) {
						listNum.push(_react2.default.createElement(
							"div",
							{ className: _PanelSelectCamps2.default.checkboxItem, key: i },
							_react2.default.createElement(_semanticUiReact.Checkbox, { className: isChecked ? _PanelSelectCamps2.default.selectedLabel : "", disabled: true, checked: isChecked, title: "Selecciona un camp per activar l'altitud", onChange: _this3.handleChange, label: item })
						));
					}
				}
			});

			return {
				campsnum: listNum,
				campsinfo: []
			};
		}
	}, {
		key: "renderFieldsList",
		value: function renderFieldsList() {
			var _this4 = this;

			if (this.state.loading) {
				return _react2.default.createElement(_semanticUiReact.Loader, { active: true });
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}

			var listsObject = this.renderFieldsItems();
			return _react2.default.createElement(
				"div",
				{ className: _PanelSelectCamps2.default.container },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h4" },
					_react2.default.createElement(_semanticUiReact.Checkbox, { onChange: function onChange(e, data) {
							return _this4.handleChange(e, data, true);
						}, label: "Tots els camps" })
				),
				_react2.default.createElement(
					"div",
					{ className: _PanelSelectCamps2.default.containerFields },
					listsObject.campsnum
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_semanticUiReact.Container,
				{ fluid: true, textAlign: "justified" },
				_react2.default.createElement(
					_semanticUiReact.Header,
					{ as: "h3" },
					CONSTANTS.STEPS[this.props.myStep].description
				),
				_react2.default.createElement(
					"div",
					null,
					this.state.missingSelectedFields && _react2.default.createElement(_semanticUiReact.Message, { negative: true, icon: "warning sign", onDismiss: this.handleDismissError, header: "Error", content: "Si us plau, selecciona algun camp per continuar" }),
					this.renderFieldsList()
				)
			);
		}
	}, {
		key: "isValid",
		value: function isValid() {

			var emptySelection = this.props.selectedfields.size <= 5;

			this.setState({ missingSelectedFields: emptySelection });

			return !emptySelection;
		}
	}, {
		key: "getJsonconfigState",
		value: function getJsonconfigState() {

			/* return {
   	prop: "selectedfields",
   	data: [...this.state.selectedfields]
   }; */

			return null;
		}
	}]);

	return PanelSelectCamps;
}(_react.Component);

exports.default = PanelSelectCamps;


PanelSelectCamps.propTypes = {
	data: _propTypes2.default.object,
	timerange: _propTypes2.default.object,
	selectedfields: _propTypes2.default.object,
	myStep: _propTypes2.default.number,
	updateJsonConfig: _propTypes2.default.func
};
